const OrganizationService = require('@/services/customers/OrganizationService')

export default function (cb, preset) {
    let value = null;

    const options = {
        sort: [{
            key: 'title',
            direction: 'ASC'
        }]
    }

    OrganizationService.findAll(options, response => {
        const body = response.data

        const results = body.rows.map((organization) => {
            return {
                label: organization.title,
                value: organization.id
            }
        })

        for (var i = 0; i < results.length; i++) {
            if (results[i].value !== preset) {
                continue
            }

            value = preset
        }

        cb(results, value)
    });
}
